import React from 'react'
import Chip from '@mui/material/Chip'
import PropTypes from 'prop-types'
import { withStyles } from '~/themes/useStyles'
import { tags } from './tags'
import { COLORS } from '~/themes/common'

const tagStyle = (theme) => ({
  root: {
    height: 32,
    fontSize: 14,
    borderRadius: 5,
    border: `1px solid ${COLORS.gray.darkGray}`,
    backgroundColor: 'white',
    margin: theme.spacing(0.5),
  },
})

const Tag = ({
  classes,
  size,
  variant,
  tag,
  fixedWidth,
  style,
  label,
  disabled,
  ...props
}) => (
  <Chip
    classes={classes}
    style={{
      color: tags[tag]?.color,
      backgroundColor: tags[tag]?.bgColor,
      minWidth: fixedWidth && 105,
      ...style,
    }}
    label={tags[tag]?.label || label}
    variant={variant}
    size={size}
    disabled={disabled}
    deleteIcon={
      <img
        src="/icons/close.svg"
        style={{
          width: 10,
          paddingLeft: 3,
          paddingRight: 3,
          opacity: disabled ? 0.3 : 1,
        }}
        alt="close"
      />
    }
    {...props}
  />
)

Tag.defaultProps = {
  size: 'medium',
  variant: 'default',
  tag: '',
  fixedWidth: false,
  disabled: false,
  style: {},
  label: '',
}

Tag.propTypes = {
  classes: PropTypes.shape().isRequired,
  size: PropTypes.string,
  variant: PropTypes.string,
  tag: PropTypes.string,
  fixedWidth: PropTypes.bool,
  style: PropTypes.shape(),
  label: PropTypes.string,
  disabled: PropTypes.bool,
}

export default withStyles(tagStyle)(Tag)
